var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-list"},_vm._l((_vm.list),function(item,key){return _c('div',{key:key,class:("breadcrumb-item " + (key === _vm.list.length -1 ? 'breadcrumb-item-end' : ''))},[_vm._v(_vm._s(key > 0 ? ' > ' : '')+_vm._s(item.name))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8314dffc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/breadcrumb/breadcrumb.vue
// module id = null
// module chunks = 